export const EnableSecurity = true;
export const HostURL_API = window.hostURL;
